import React, { useState, useEffect, useRef } from 'react';
import { formatMoneda } from '../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@material-ui/core';
import useTableScroll from '../useTableScrollcesar';
import { Mensaje, MensajeSiNo } from '../mensajes';
import { ModalIncluirFactura } from './modalIncluirFactura';

const TablaRetenciones = (props) => {

    const headCells = [
        { label: 'Código', textAlign: 'center' },
        { label: 'Descripción', textAlign: 'center' },
        { label: 'Base Imponible', textAlign: 'center' },
        { label: 'Alicuota', textAlign: 'center' },
        { label: 'Total Retenido', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead
    } = useTableScroll(headCells);

    const [mostrar2, setMostrar2] = useState(false);
    const [records, setRecords] = useState([]);
    const [datos, setDatos] = useState([]);
    const [idcor, setIdcor] = useState([]);
    const [itemSelect, setItemSelect] = useState(null);
    const [opr, setOpr] = useState(0);
    const [idope, setIdope] = useState(null);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activ, setActiv] = useState(true);

    useEffect(() => {

        if (props.renderiza === 0 || props.renderiza === 8) {
            setRecords([]);
            setDatos([]);
            setIdcor([]);
            setItemSelect(null);
            setIdope(null);
            setOpr(0);
            setActiv(true);
            setMostrar2(false);
        }

    }, [props.renderiza]);

    useEffect(() => {

        if (props.render.length > 0) {

            let datarend = [...props.render];
            let datos = [];

            for (let i = 0; i < records.length; i++) {

                if (records[i].codigo === '1') {

                    let base = datarend[0].base * records[i].iva / 100;
                    let totalr = base * records[i].alicuota / 100;

                    datos.push({
                        codigo: records[i].codigo,
                        descripcion: records[i].descripcion,
                        baseimponible: base,
                        alicuota: records[i].alicuota,
                        total: totalr,
                        fecha: records[i].fecha,
                        iva: records[i].iva,
                        totalf: datarend[0].base,
                        montoiva: datarend[0].montoiva,
                        unidad:  records[i].unidad,
                    });

                } else if (records[i].codigo === '2') {

                    let base = datarend[0].base * records[i].alicuota / 100;

                    datos.push({
                        codigo: records[i].codigo,
                        descripcion: records[i].descripcion,
                        baseimponible: datarend[0].base,
                        alicuota: records[i].alicuota,
                        total: base,
                        fecha: records[i].fecha,
                        iva: records[i].iva,
                        totalf: datarend[0].base,
                        montoiva: datarend[0].montoiva,
                        unidad:  records[i].unidad,
                    });

                } else if (parseInt(records[i].unidad) === 3) {
                    
                    datos.push({
                        codigo: records[i].codigo,
                        descripcion: records[i].descripcion,
                        baseimponible: datarend[0].base,
                        alicuota: records[i].alicuota,
                        total: records[i].total,
                        fecha: records[i].fecha,
                        iva: records[i].iva,
                        totalf: datarend[0].base,
                        montoiva: datarend[0].montoiva,
                        unidad:  records[i].unidad,
                    });

                } else if (parseInt(records[i].unidad) === 4) {
                    
                    let base = datarend[0].base / records[i].alicuota;

                    datos.push({
                        codigo: records[i].codigo,
                        descripcion: records[i].descripcion,
                        baseimponible: datarend[0].base,
                        alicuota: records[i].alicuota,
                        total: base,
                        fecha: records[i].fecha,
                        iva: records[i].iva,
                        totalf: datarend[0].base,
                        montoiva: datarend[0].montoiva,
                        unidad:  records[i].unidad,
                    });

                }
            }
            setRecords(datos);
            props.baser(datos, 4);
        } else {
            setRecords([]);
        }

    }, [props.render]);


    useEffect(() => {

        if (props.datostabla.length > 0) {
            setRecords(props.datostabla);
        };

    }, [props.datostabla]);

    const datoopcal = (datos, op) => {

        if (opr === 2 && op === 6) {
            props.baser(datos, 5);
        };
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    const ModalFact = (datos) => {
        setMostrar2(false);
        var data = [];

        for (let i = 0; i < records.length; i++) {

            data.push({
                codigo: records[i].codigo,
                descripcion: records[i].descripcion,
                baseimponible: records[i].baseimponible,
                alicuota: records[i].alicuota,
                total: records[i].total,
                fecha: records[i].fecha,
                iva: records[i].iva,
                totalf: records[i].totalf,
                montoiva: records[i].montoiva,
                unidad: records[i].unidad
            });
        }

        if (opr === 2) {
            data[idope] = {

                codigo: datos[0].codigo,
                descripcion: datos[0].descripcion,
                baseimponible: datos[0].baseimponible,
                alicuota: datos[0].alicuota,
                total: datos[0].total,
                fecha: datos[0].fecha,
                iva: datos[0].iva,
                totalf: datos[0].totalf,
                montoiva: datos[0].montoiva,
                unidad: datos[0].unidad
                

            };
            setItemSelect(null);
        } else {
            data.push({
                codigo: datos[0].codigo,
                descripcion: datos[0].descripcion,
                baseimponible: datos[0].baseimponible,
                alicuota: datos[0].alicuota,
                total: datos[0].total,
                fecha: datos[0].fecha,
                iva: datos[0].iva,
                totalf: datos[0].totalf,
                montoiva: datos[0].montoiva,
                unidad: datos[0].unidad
            });
        }
        setRecords(data);
        props.baser(data);
    }

    const eliminarFact = (n, index) => (e) => {
        e.preventDefault();
        var data = [...records];
        var elementos = [];
        var paraeli = [];

        for (let i = 0; i < data.length; i++) {

            if (n !== data[i].codigo) {
                elementos.push(data[i]);
            }

        }

        paraeli.push({

            codigo: data[index].codigo,
            descripcion: data[index].descripcion,
            baseimponible: data[index].baseimponible,
            alicuota: data[index].alicuota,
            total: data[index].total,
            fecha: data[index].fecha,
            iva: data[index].iva,
            totalf: data[index].totalf,
            montoiva: data[index].montoiva,
            unidad: data[index].unidad

        });
        setItemSelect(null);
        setRecords(elementos);
        props.baser(elementos, paraeli, n);

    }

    const seleccionarFila = (index, item) => () => {
        setItemSelect(item.codigo);
        if (item.codigo !== '') {
            setActiv(false);
        } else {
            setActiv(true);
        }
        setIdope(index);
    };

    const gestionar = (index, op) => (e) => {
        e.preventDefault();

        if (op === 1) {
            let p = [...records];
            if (p.length > 0) {
                setIdcor(p);
            } else {
                setIdcor([]);
            }
            setMostrar2(true);
            setOpr(op);
        } else if (op === 2) {
            setOpr(op);
            let data = [...records];
            let info = [];
            info.push({

                codigo: data[index].codigo,
                descripcion: data[index].descripcion,
                baseimponible: data[index].baseimponible,
                alicuota: data[index].alicuota,
                total: data[index].total,
                fecha: data[index].fecha,
                iva: data[index].iva,
                totalf: data[index].totalf,
                montoiva: data[index].montoiva,
                idtiporetencion: data[index].codigo,
                deducible: data[index].deducible,
                unidad: data[index].unidad

            });
            setDatos(info);
            setMostrar2(true);
            props.baser(0, info, 7);
        }

    }

    const hanCancelar = () => {
        setMostrar2(false);
        setItemSelect(null);
        setIdope(null);
        setActiv(true);
    }

    return (
        <div className=''>
            <ModalIncluirFactura
                show={mostrar2}
                onHideCancelar={hanCancelar}
                onHideDatos={ModalFact}
                data={props.datosfact}
                datos={datos}
                idc={idcor}
                operacion={opr}
                inf={datoopcal}
            />
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

            <div className='col-md-12 row m-0'>
                <div className="col-md-11">
                    <TblContainer container={{ height: 120, width: '100%', overflow: 'auto', padding: '2px' }} >
                        <TblHead />
                        <TableBody className='overflow-hidden table-bordered'>
                            {
                                records && records.map((item, index) => (
                                    <TableRow key={index} style={{ padding: "0", cursor: props.op === 4 || props.op === 3 ? 'none' : 'pointer', background: itemSelect === item.codigo ? "lightskyblue" : "white" }} onClick={props.op === 4 || props.op === 3 ? '' : seleccionarFila(index, item)}>
                                        <TableCell className='align-baseline' style={{ textAlign: "center", width: '30px' }} >{item.codigo}</TableCell>
                                        <TableCell className='align-baseline' style={{ textAlign: "center", width: '120px' }} >{item.descripcion}</TableCell>
                                        <TableCell className='align-baseline text-right' style={{ width: '80px' }} >{formatMoneda(item.baseimponible.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</TableCell>
                                        <TableCell className='align-baseline text-right' style={{ width: '30px' }} >{formatMoneda(item.alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</TableCell>
                                        <TableCell className='align-baseline text-right' style={{ width: '80px' }} >{formatMoneda(item.total.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </TblContainer>
                </div>
                <div className='col-md-1 m-auto px-0'>
                    <div className='col-md-12 mb-1 px-0'>
                        <button onClick={gestionar(idope, 1)} disabled={props.op === 0 || props.op === 8 || props.op === 1 || props.op === 4 || props.op === 3 ? true : false} className="btn btn-sm btn-primary rounded-pill w-100" title='Incluir'><i className="fas fa-plus"> <span className='ocultabotones'>Incluir</span></i></button>
                    </div>

                    <div className='col-md-12 mb-1 px-0'>
                        <button onClick={gestionar(idope, 2)} disabled={activ} className="btn btn-sm btn-warning rounded-pill w-100" title='Modificar'><i className="fa fa-edit"> <span className='ocultabotones'>Modificar</span></i></button>
                    </div>

                    <div className='col-md-12 px-0'>
                        <button onClick={eliminarFact(itemSelect, idope)} disabled={activ} className="btn btn-sm btn-danger rounded-pill w-100" title='Eliminar'><i className="fa fa-trash"> <span className='ocultabotones'>Eliminar</span></i></button>
                    </div>

                </div>
            </div>
        </div >
    );
}
export default TablaRetenciones;



// WEBPACK FOOTER //
// ./src/components/compra/tablaRetenciones.js